import { useAuth } from 'src/auth'
import { logOutAndSyncTabs } from 'src/lib/crossTabLogout'

/** `logOut` that also makes this app's other tabs re-check their session. */
export const useLogOutAndSyncTabs = () => {
  const { logOut } = useAuth()

  return () => logOutAndSyncTabs(logOut)
}
